import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss'],
})
export class UploadComponent implements OnInit {
    @Input() acceptedExtensions: string = '';
    @Input() maxSizeInMb: number;

    @Output() fileUploaded = new EventEmitter<File>();
    @Output() fileSizeError = new EventEmitter<boolean>();

    fileExtensionError = false;
    constructor() {}

    ngOnInit(): void {}

    onFileUploadedChanged(event: FileList) {
        const file = event.item(0);
        const fileExtension = file.name.split('.').pop();
        if (this.maxSizeInMb && file.size > this.maxSizeInMb * 1024 * 1024) {
            this.fileSizeError.emit(true);
            return;
        }
        const acceptedExtensions = this.acceptedExtensions.split(',');
        if (!acceptedExtensions.includes('.' + fileExtension)) {
            this.fileExtensionError = true;
            return;
        }

        this.fileUploaded.emit(file);
        this.fileSizeError.emit(false);
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        const file = event.dataTransfer.files.item(0);
        this.fileUploaded.emit(file);
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    resetFiles($event) {
        $event.target.value = '';
    }
}
